<template>
	<div class="c-search__scanner">
		<button type="button" @click="openQRScanner"><i class="fal fa-qrcode"></i></button>
		<div v-show="showQrScanner" id="qrscanner-modal" class="barcode-modal">
			<div class="barcode-modal--dialog">
				<div class="barcode-modal--content">
					<div class="barcode-modal--header">
						<h3>Scanner</h3>
						<button type="button" class="barcode-modal--close" aria-label="Close" @click="destroyQRScanner">
							<span aria-hidden="true"><i class="fal fa-times"></i></span>
						</button>
					</div>
					<div class="barcode-modal--body">
						<div class="qr-container">
							<template v-if="!showError">
								<div class="qr-wrapper">
									<div id="qr-reader"></div>
									<div class="qr-wrapper-box">
										<div></div>
										<div></div>
										<div></div>
										<div></div>
									</div>
								</div>
								<div v-if="cameraList.length >= 0" class="barcode-qr--inner-box">
									<select v-model="selectedCamera" class="form-control" @change="changeQRcamera(selectedCamera)">
										<option value="" disabled>Switch camera</option>
										<option v-for="camera in cameraList" :key="camera.id" :value="camera.id">{{ camera.label }}</option>
									</select>
								</div>
							</template>
							<div v-else class="barcode-qr--inner-box">
								<p>De scanner kon niet geopend worden.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode';
import azuresearch from '../products/plugins/azureSearch';
import searchOverviewSettings from '../../modules/products/domain/searchOverviewSettings.js';

export default {
	components: {},
	// eslint-disable-next-line vue/require-prop-types
	props: ['data'],
	data: () => ({
		qrScanner: {},
		showQrScanner: false,
		showError: false,
		cameraList: [],
		selectedCamera: '',
		qrScannerLock: false,
		searchOverviewSettings
	}),
	computed: {},
	created() {
		this.createInitialSearchRequest();
	},
	methods: {
		createInitialSearchRequest() {
			// create inital search settings
			this.searchOverviewSettings = Object.assign({}, searchOverviewSettings);
			searchOverviewSettings.searchSettings.apiSettings = {
				apiVersion: '2017-11-11',
				corsSettings: [],
				indexName: 'aquaco-abp-articles-' + this.data.azureSearchIndexName,
				searchServiceAdminApiKey: '',
				searchServiceName: null,
				searchServiceQueryApiKey: '3ADAC7C0EEF51BB4DF3D19C93C704A02',
				url: 'https://prod-aquaco-search.search.windows.net'
			};

			this.searchApi = new azuresearch.AzureSearchApi(this.searchSettings);

			// minimize response to only the required fields
			searchOverviewSettings.searchSettings.searchRequest.select = 'DetailUrl, Code';
			searchOverviewSettings.searchSettings.searchRequest.top = 1;
			searchOverviewSettings.searchSettings.searchRequest.count = false;
		},
		async search(searchQuery) {
			try {
				// set the filter (we dont search but only filter on code)
				this.searchOverviewSettings.searchSettings.searchRequest.filter = `Code eq '${searchQuery}'`;

				const response = await this.searchApi.search(this.searchOverviewSettings.searchSettings.searchRequest);
				const resultItem = response.data.value[0];
				if (resultItem && resultItem.Code === searchQuery) {
					return resultItem.DetailUrl;
				} else {
					return '/barcode-error-page';
				}
			} catch {}
		},

		async onScanSuccess(result) {
			if (!this.qrScannerLock) {
				// lock result parse to prevent double scan
				let redirectUrl = result;

				const isUrl = result.includes('.');
				if (!isUrl) {
					// sanitize scan result
					result = result.replace(/[^A-Za-z0-9]/g, '');
					// search page with azureSearch
					redirectUrl = await this.search(result);
				}

				// desproy QR Scanner
				this.destroyQRScanner();
				this.qrScannerLock = false;
				// redirect to page
				window.location.assign(redirectUrl);
			}
		},
		destroyQRScanner() {
			// when the scanner gets destroyed we do not know for sure if it was created
			try {
				this.showQrScanner = false;
				this.qrScanner.stop();
				this.qrScanner = null;
			} catch {}

			this.setBodyClass('modalopen', false);
		},
		openQRScanner() {
			// https://scanapp.org/html5-qrcode-docs/docs/intro
			// De 'qr-reader' verwijst naar het id van het element waar de camera feed getoond moet worden.
			this.showQrScanner = true;
			this.showError = false;
			this.setBodyClass('modalopen', true);
			// This method will trigger user permissions
			Html5Qrcode.getCameras()
				.then(devices => {
					if (devices && devices.length) {
						this.cameraList = devices;
						this.qrScanner = new Html5Qrcode('qr-reader');
						const qrCodeSuccessCallback = (decodedText, decodedResult) => {
							this.onScanSuccess(decodedText);
						};
						const config = { fps: 25, aspectRatio: 1 / 1 };

						if (this.selectedCamera === '') {
							this.qrScanner.start({ facingMode: 'environment' }, config, qrCodeSuccessCallback);
						} else {
							this.qrScanner.start({ deviceId: { exact: this.selectedCamera } }, config, qrCodeSuccessCallback);
						}
					}
				})
				.catch(err => {
					console.log(err);
					this.showError = true;
				});
		},
		changeQRcamera(id) {
			this.selectedCamera = id;
			this.qrScanner.stop();
			this.openQRScanner();
		},
		setBodyClass(key, bool) {
			if (bool) document.body.classList.add(key);
			else document.body.classList.remove(key);
		}
	}
};
</script>
